import type {
  AdapterInterruptMode,
  AdapterInterruptSignal,
} from "@wakeloop/adapter-core";
import type {
  WakeLoopDaemonControlPlaneRequest,
  WakeLoopDaemonControlPlaneResponse,
  WakeLoopDaemonControlTargetSelector,
} from "@wakeloop/schemas/types";

export type InflightTaskControlRecord = {
  adapterId: string;
  dispatchId: string;
  processId: number | null;
  runtimeCoordinatorExecutionId: string | null;
  taskId: string;
  updatedAt: string;
};

export type ControlSignalResult = {
  dispatchId: string;
  processId: number;
  taskId: string;
  unixSignal: NodeJS.Signals;
};

export type LocalTaskInterruptSender = (
  signal: AdapterInterruptSignal
) => Promise<ControlSignalResult>;

export type LocalTaskInterruptErrorCode =
  | "signal.send_failed"
  | "task.not_found"
  | "task.not_running";

export type LocalControlCommandName = Extract<
  WakeLoopDaemonControlPlaneRequest["command"],
  "cancel" | "interrupt"
>;

export type LocalControlAcceptedResponse = Extract<
  WakeLoopDaemonControlPlaneResponse,
  { code: "service.cancel" | "service.interrupt" }
>;

export type LocalControlPlaneRequest = Extract<
  WakeLoopDaemonControlPlaneRequest,
  { command: "cancel" | "interrupt" }
>;

export type LocalControlTargetSelector = WakeLoopDaemonControlTargetSelector;

export type LocalControlResolution = {
  record: InflightTaskControlRecord;
  target: WakeLoopDaemonControlTargetSelector;
};

export type LocalControlRequestHandler = (
  request: WakeLoopDaemonControlPlaneRequest
) => Promise<WakeLoopDaemonControlPlaneResponse>;

export const resolveUnixSignalForInterruptMode = (
  mode: AdapterInterruptMode
): NodeJS.Signals => (mode === "force" ? "SIGKILL" : "SIGTERM");
